import {
  Alert,
  Card,
  NumberInput,
  TextInput,
  SimpleSelect,
} from 'corso-admin-ui';
import { Pegasus } from 'corso-types';
import { Controller, useWatch } from 'react-hook-form';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import {
  CUSTOM_PARCEL,
  CUSTOM_PARCEL_NAME,
  findPredefinedParcelByDimensions,
  parcelSelectOptions,
  predefinedParcels,
} from './predefinedParcels';

export default function EventQuoteOrderShipmentParcel() {
  const { control, register, setValue } = useAutomationFormContext();

  const length = useWatch({ control, name: 'event.params.parcel.length' });
  const width = useWatch({ control, name: 'event.params.parcel.width' });
  const height = useWatch({ control, name: 'event.params.parcel.height' });

  const predefinedParcel = findPredefinedParcelByDimensions({
    length,
    width,
    height,
  });

  const selectedParcel = predefinedParcel ?? CUSTOM_PARCEL;

  const handleSetParcel = (parcelName: Pegasus.Parcel['name']) => {
    const foundParcel = predefinedParcels.find((p) => p.name === parcelName);
    if (!foundParcel) {
      setValue('event.params.parcel.name', CUSTOM_PARCEL_NAME, {
        shouldDirty: true,
      });
      return;
    }
    setValue('event.params.parcel.name', foundParcel.name, {
      shouldDirty: true,
    });
    setValue('event.params.parcel.length', foundParcel.length, {
      shouldDirty: true,
    });
    setValue('event.params.parcel.width', foundParcel.width, {
      shouldDirty: true,
    });
    setValue('event.params.parcel.height', foundParcel.height, {
      shouldDirty: true,
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <Card>
        <SimpleSelect
          options={parcelSelectOptions}
          label="Type"
          value={selectedParcel.name}
          defaultValue={selectedParcel.name}
          onChange={handleSetParcel}
        />

        {!predefinedParcel && (
          <>
            <TextInput
              id="parcel-name"
              required
              label="Name"
              details="The name of the parcel"
              {...register('event.params.parcel.name')}
            />

            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              <Controller
                control={control}
                name="event.params.parcel.length"
                render={({ field, fieldState }) => (
                  <NumberInput
                    step={0.01}
                    required
                    label="Length"
                    value={field.value}
                    id="parcel-length"
                    error={fieldState.error?.message}
                    addon={{ insideEnd: 'in' }}
                    onChange={(e) => field.onChange(e.target.valueAsNumber)}
                  />
                )}
              />
              <Controller
                control={control}
                name="event.params.parcel.width"
                render={({ field, fieldState }) => (
                  <NumberInput
                    required
                    step={0.01}
                    label="Width"
                    value={field.value}
                    id="parcel-width"
                    error={fieldState.error?.message}
                    addon={{ insideEnd: 'in' }}
                    onChange={(e) => field.onChange(e.target.valueAsNumber)}
                  />
                )}
              />
              <Controller
                control={control}
                name="event.params.parcel.height"
                render={({ field, fieldState }) => (
                  <NumberInput
                    required
                    step={0.01}
                    label="Height"
                    value={field.value}
                    id="parcel-height"
                    error={fieldState.error?.message}
                    addon={{ insideEnd: 'in' }}
                    onChange={(e) => field.onChange(e.target.valueAsNumber)}
                  />
                )}
              />
            </div>

            <Alert
              variant="info"
              heading="Custom Parcel Size. Ensure compatibility with your selected carrier rates."
            />
          </>
        )}
      </Card>
    </div>
  );
}
